import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletConnectComponent } from './wallet-connect/wallet-connect.component';
import { WalletConnectScanComponent } from './wallet-connect-scan/wallet-connect-scan.component';
import { WalletComponent } from './wallet/wallet.component';
import { WalletWatchComponent } from './wallet-watch/wallet-watch.component';
import { WalletViewComponent } from './wallet-view/wallet-view.component';
import { WalletMngComponent } from './wallet-mng/wallet-mng.component';
import { UserComponent } from './user/user.component';
import { WalletSeedBlackComponent } from './wallet-seed-black/wallet-seed-black.component';
import { LogoComponent } from './logo/logo.component';
import { BalanceOffComponent } from './balance-off/balance-off.component';
import { BalanceOnComponent } from './balance-on/balance-on.component';
import { ListCollapseComponent } from './list-collapse/list-collapse.component';
import { ListExpandComponent } from './list-expand/list-expand.component';
import { ArrowDownComponent } from './arrow-down/arrow-down.component';
import { ArrowsSwapComponent } from './arrows-swap/arrows-swap.component';
import { WalletBoldComponent } from './wallet-bold/wallet-bold.component';
import { FilterMinimalComponent } from './filter-minimal/filter-minimal.component';
import { DappsComponent } from './dapps/dapps.component';
import { ExchangeComponent } from './exchange/exchange.component';
import { MoreComponent } from './more/more.component';
import { ViewBoxComponent } from './view-box/view-box.component';
import { ViewRowComponent } from './view-row/view-row.component';
import { RefreshComponent } from './refresh/refresh.component';
import { ListDetailsComponent } from './list-details/list-details.component';
import { ShareIconComponent } from './share-icon/share-icon.component';
import { SignOutComponent } from './sign-out/sign-out.component';
import { AccountComponent } from './account/account.component';
import { KeyBackupComponent } from './key-backup/key-backup.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { LockComponent } from './lock/lock.component';
import { WalletExportComponent } from './wallet-export/wallet-export.component';
import { WalletImportComponent } from './wallet-import/wallet-import.component';
import { ThemeComponent } from './theme/theme.component';
import { SecurityIconComponent } from './security-icon/security-icon.component';
import { NetworkComponent } from './network/network.component';
import { LanguageComponent } from './language/language.component';
import { ClearAndExitComponent } from './clear-and-exit/clear-and-exit.component';
import { NotificationComponent } from './notification/notification.component';
import { TelegramComponent } from './telegram/telegram.component';
import { CopyIconComponent } from './copy-icon/copy-icon.component';
import { CopyComponent } from '@shared/copy/copy.component';
import { ExternalLinkComponent } from './external-link/external-link.component';
import { WalletSmComponent } from './wallet-sm/wallet-sm.component';
import { WalletSmallComponent } from './wallet-small/wallet-small.component';
import { PasteSmallComponent } from './paste-small/paste-small.component';
import { QrSmallComponent } from './qr-small/qr-small.component';
import { ListComponent } from './list/list.component';
import { CloseComponent } from './close/close.component';
import { SettingsComponent } from './settings/settings.component';
import { PaymentHistoryDetailsComponent } from './payment-history-details/payment-history-details.component';
import { NftTemplateComponent } from './nft-template/nft-template.component';
import { ArrowRightComponent } from './arrow-right/arrow-right.component';
import { BrowseComponent } from './browse/browse.component';
import { WalletImgComponent } from './wallet-img/wallet-img.component';
import { AddIconComponent } from './add-icon/add-icon.component';
import { WalletVisibleComponent } from './wallet-visible/wallet-visible.component';
import { GearSmallComponent } from './gear-small/gear-small.component';
import { ArrowDownSimpleComponent } from './arrow-down-simple/arrow-down-simple.component';
import { WalletHiddenComponent } from './wallet-hidden/wallet-hidden.component';
import { LoaderComponent } from './loader/loader.component';
import { RemoveComponent } from './remove/remove.component';
import { TouchIdComponent } from './touch-id/touch-id.component';
import { CloseRoundComponent } from './close-round/close-round.component';
import { AlertLightComponent } from './alert-light/alert-light.component';
import { AlertIconComponent } from './alert-icon/alert-icon.component';
import { KeyBackupLightComponent } from './key-backup-light/key-backup-light.component';
import { ProcessingComponent } from './processing/processing.component';
import { ExchangeMarketsComponent } from './exchange-markets/exchange-markets.component';
import { HistoryIconComponent } from './history-icon/history-icon.component';
import { GearComponent } from './gear/gear.component';
import { DappIconDefaultComponent } from './dapp-icon-default/dapp-icon-default.component';
import { HyperIdComponent } from './hyper-id/hyper-id.component';
import { IconProcessingGearComponent } from './icon-processing-gear/icon-processing-gear.component';
import { IconProcessingAngularComponent } from './icon-processing-angular/icon-processing-angular.component';
import { InvestComponent } from './invest/invest.component';
import { NftIconDefaultComponent } from './nft-icon-default/nft-icon-default.component';
import { RemoveBigComponent } from './remove-big/remove-big.component';
import { SwapComponent } from './swap/swap.component';
import { WalletStyleWhiteComponent } from './wallet-style-white/wallet-style-white.component';
import { WalletKeyComponent } from './wallet-key/wallet-key.component';
import { LockThinComponent } from './lock-thin/lock-thin.component';
import { SignOutThinComponent } from './sign-out-thin/sign-out-thin.component';

@NgModule({
  declarations: [
    WalletConnectComponent,
    WalletConnectScanComponent,
    WalletComponent,
    WalletWatchComponent,
    WalletViewComponent,
    WalletMngComponent,
    UserComponent,
    WalletSeedBlackComponent,
    LogoComponent,
    BalanceOffComponent,
    BalanceOnComponent,
    ListCollapseComponent,
    ListExpandComponent,
    ArrowDownComponent,
    ArrowsSwapComponent,
    WalletBoldComponent,
    FilterMinimalComponent,
    DappsComponent,
    ExchangeComponent,
    MoreComponent,
    ViewBoxComponent,
    ViewRowComponent,
    RefreshComponent,
    ListDetailsComponent,
    ShareIconComponent,
    SignOutComponent,
    AccountComponent,
    KeyBackupComponent,
    InvoiceComponent,
    LockComponent,
    WalletExportComponent,
    WalletImportComponent,
    ThemeComponent,
    SecurityIconComponent,
    NetworkComponent,
    LanguageComponent,
    ClearAndExitComponent,
    NotificationComponent,
    TelegramComponent,
    CopyIconComponent,
    ExternalLinkComponent,
    WalletSmComponent,
    WalletSmallComponent,
    PasteSmallComponent,
    QrSmallComponent,
    ListComponent,
    CloseComponent,
    SettingsComponent,
    PaymentHistoryDetailsComponent,
    NftTemplateComponent,
    ArrowRightComponent,
    BrowseComponent,
    WalletImgComponent,
    AddIconComponent,
    WalletVisibleComponent,
    GearSmallComponent,
    ArrowDownSimpleComponent,
    WalletHiddenComponent,
    LoaderComponent,
    RemoveComponent,
    TouchIdComponent,
    CloseRoundComponent,
    AlertLightComponent,
    AlertIconComponent,
    KeyBackupLightComponent,
    ProcessingComponent,
    ExchangeMarketsComponent,
    HistoryIconComponent,
    GearComponent,
    DappIconDefaultComponent,
    HyperIdComponent,
    IconProcessingGearComponent,
    IconProcessingAngularComponent,
    InvestComponent,
    NftIconDefaultComponent,
    RemoveBigComponent,
    SwapComponent,
    WalletStyleWhiteComponent,
    WalletKeyComponent,
    LockThinComponent,
    SignOutThinComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WalletConnectComponent,
    WalletConnectScanComponent,
    WalletComponent,
    WalletWatchComponent,
    WalletViewComponent,
    WalletMngComponent,
    WalletSeedBlackComponent,
    UserComponent,
    LogoComponent,
    BalanceOffComponent,
    BalanceOnComponent,
    ListCollapseComponent,
    ListExpandComponent,
    ArrowDownComponent,
    ArrowsSwapComponent,
    WalletBoldComponent,
    FilterMinimalComponent,
    DappsComponent,
    ExchangeComponent,
    MoreComponent,
    ViewBoxComponent,
    ViewRowComponent,
    RefreshComponent,
    ListDetailsComponent,
    ShareIconComponent,
    SignOutComponent,
    AccountComponent,
    KeyBackupComponent,
    InvoiceComponent,
    LockComponent,
    WalletExportComponent,
    WalletImportComponent,
    ThemeComponent,
    SecurityIconComponent,
    NetworkComponent,
    LanguageComponent,
    ClearAndExitComponent,
    NotificationComponent,
    TelegramComponent,
    CopyIconComponent,
    ExternalLinkComponent,
    WalletSmComponent,
    WalletSmallComponent,
    PasteSmallComponent,
    QrSmallComponent,
    ListComponent,
    CloseComponent,
    SettingsComponent,
    PaymentHistoryDetailsComponent,
    NftTemplateComponent,
    ArrowRightComponent,
    BrowseComponent,
    WalletImgComponent,
    AddIconComponent,
    WalletVisibleComponent,
    GearSmallComponent,
    ArrowDownSimpleComponent,
    WalletHiddenComponent,
    LoaderComponent,
    RemoveComponent,
    TouchIdComponent,
    CloseRoundComponent,
    AlertLightComponent,
    AlertIconComponent,
    KeyBackupLightComponent,
    ProcessingComponent,
    ExchangeMarketsComponent,
    HistoryIconComponent,
    GearComponent,
    DappIconDefaultComponent,
    HyperIdComponent,
    IconProcessingGearComponent,
    IconProcessingAngularComponent,
    InvestComponent,
    NftIconDefaultComponent,
    RemoveBigComponent,
    SwapComponent,
    WalletStyleWhiteComponent,
    WalletKeyComponent,
    LockThinComponent,
    SignOutThinComponent
  ]
})
export class IconsModule { }
